module.exports = __webpack_public_path__ + "img/flower1.362c7d8b.gif";